import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [RouterLink, CommonModule, ]
})
export class FooterComponent {
  isShow: boolean = false;
  IsShow: boolean = false;
  onChanges() {
    this.isShow = true;
    this.IsShow = false;
  }
  onChange() {
    this.IsShow = true;
    this.isShow = false;
  }
}
